import type { EmbedData } from 'ricos-schema';
import { PluginContainerData_Alignment } from 'ricos-schema';

export const DEFAULTS = {
  config: {
    alignment: 'center',
    size: 'content',
    link: {
      target: '_blank',
      rel: '',
    },
  },
};

export const EMBED_DEFAULTS: EmbedData = {
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    textWrap: true,
    width: {
      size: undefined,
      custom: '350',
    },
  },
};
